import type {
  APIConnector,
  RequestState,
  QueryConfig,
  ResponseState,
  AutocompleteResponseState,
  AutocompleteQueryConfig,
} from '@elastic/search-ui';

const jobRoutes = JSON.parse(process.env.REACT_APP_BASE_URL!);

class MyAPIConnector implements APIConnector {
  async onSearch(
    state: RequestState,
    queryConfig: QueryConfig
  ): Promise<ResponseState> {
    const lat = (window as any).lat;
    const lng = (window as any).lng;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: { ...state },
        options: { ...queryConfig },
        sort_location_geo: lat && lng ? [lat, lng] : undefined,
      }),
    });

    return response.json();
  }

  async onAutocomplete(
    state: RequestState,
    queryConfig: AutocompleteQueryConfig
  ): Promise<AutocompleteResponseState> {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/autocomplete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: { ...state },
        options: { ...queryConfig },
      }),
    });

    return response.json();
  }

  onResultClick(params: any): void {
    let url;
    const brand = params.result.cf_brand && params.result.cf_brand.raw.toLowerCase();
    const exceptionsBrandsToRedirect = [
      'baywa haustechnik gmbh',
      'baywa stiftung',
      'baywa bau projekt gmbH',
      'baywa obst gmbh & co. kg'
    ];    

    const currentPath = window.location.pathname;
    var baseUrl =  jobRoutes.find((jobRoute : string) => currentPath.startsWith(jobRoute));
    
    if(brand.includes('baywa') && !exceptionsBrandsToRedirect.some(entry => entry.includes(brand))) {            
    var baseUrl =  jobRoutes.find((jobRoute : string) => currentPath.startsWith(jobRoute));
      url = `${baseUrl === '/' ? '' : baseUrl }/${params.result.id.raw}`
    } else {
      url = params.result.posting_url.raw;      
    }

    window.open(
      url,
      '_blank',
      'noopener, noreferrer'
    );
  }

  onAutocompleteResultClick(params: any): void {}
}

export default MyAPIConnector;
